import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class ReportingService {
    private legacyApiBaseUrl = '/v1/reporting';

    constructor(private http: HttpClient) {}

    getStandardReport(report: string, filters?: any): Promise<any> {
        let endpoint = `${this.legacyApiBaseUrl}/${report}`;
        if (filters) {
            endpoint += '?' + $.param(filters);
        }
        return this.http.get(endpoint).toPromise().then(this.returnJson).catch(this.throwError);
    }

    getStandardReportExport(report: string, filters?: any): Observable<any> {
        let endpoint = `${this.legacyApiBaseUrl}/${report}`;
        if (filters) {
            endpoint += '?' + $.param(filters);
        }
        return this.http.get(endpoint, { responseType: 'blob' });
    }

    /*************************
     * Callbacks
     *********************** */
    private returnJson(res: HttpResponse<any>): Promise<HttpResponse<any>> | Promise<never> {
        try {
            return Promise.resolve(res);
        } catch (e) {
            console.error('Failed to parse the JSON response from the server', res);
            return Promise.reject(res);
        }
    }

    private throwError(error: any): Promise<never> {
        return Promise.reject(error);
    }
}
